const NavigationModel = {
    findByPermalink: (permalink, navigations = [], index) => {
        const navigation = navigations
            && navigations.katapulk
            && navigations.katapulk.taxons.find((navigation) => `/t/${navigation.permalink}` === permalink);

        return navigation || (navigations
            && navigations.katapulk
            && navigations.katapulk.taxons[index].taxons
                .find((navigation) => `/t/${navigation.permalink}` === permalink));
    },
};

export default NavigationModel;



/** WEBPACK FOOTER **
 ** ./src/services/navigation-model.js
 **/